import { t } from "@/i18n-js/instance";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Typography } from "@circle-react-uikit/Typography";

interface TOCHeaderProps {
  hideTOC: () => void;
}

export const TOCHeader = ({ hideTOC }: TOCHeaderProps) => {
  const { translatedLabels } = useCourseCustomLabels();
  return (
    <div className="border-primary border-b">
      <div className="flex min-h-[63px] w-full items-center justify-between px-6 py-4 md:w-[360px]">
        <Typography.TitleSm as="h3" weight="semibold">
          {translatedLabels.lesson.plural}
        </Typography.TitleSm>
        <IconButton
          name="20-close"
          iconSize={20}
          ariaLabel={t("close")}
          onClick={hideTOC}
          iconClassName="!text-dark"
        />
      </div>
    </div>
  );
};
